window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-module="accordion"]').forEach(el => {
		el.querySelector('[data-accordion="toggler"]').addEventListener('click', (e) =>  toggleState(e));

		const toggleState = (e) => {
			const panel = e.currentTarget.parentNode.querySelector('[data-accordion="panel"]');
			panel.style.maxHeight = e.currentTarget.getAttribute('aria-expanded') === 'false' ? `${panel.scrollHeight + 15}px` : '0px';
			e.currentTarget.getAttribute('aria-expanded') === 'false' ? e.currentTarget.setAttribute('aria-expanded', 'true') : e.currentTarget.setAttribute('aria-expanded', 'false');
		}
	});
});